<template>
  <v-sheet v-if="is_edit" color="white" elevation="0" class="pa-5">
    <v-progress-circular
      v-if="is_loading"
      class="d-flex ms-auto mr-auto"
      indeterminate
      color="primary"
    />
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="index < items.length - 1 ? 'mb-5' : ''"
    >
      <div class="d-flex">
        <tooltip
          placement="left"
          max-width="300"
          theme="light"
          :content="$t(get_type(item).tooltip)"
        >
          <div class="mr-1">
            <v-icon :color="get_icon_color(item.data.state)"> {{ get_type(item).icon }} </v-icon>
          </div>
        </tooltip>

        <div>
          <div class="d-flex mb-1">
            <div class="mr-2">{{ item.user_name || 'Enot CRM 🦝' }}</div>
            <div class="content--comments">
              {{ format_date(item.event_date) }}
            </div>
          </div>
          <div class="d-flex">
            <div v-if="!!get_type(item).title" class="mb-2">
              {{ get_type(item).title }}
            </div>
          </div>

          <div v-if="item.event_type !== 'call_event' && item.event_type !== 'created'">
            <div v-for="(k, index) in get_content(item.data)" :key="index">
              <div v-if="is_good_list(k)">
                <div class="mb-2">{{ k.title }}</div>
                <goods :items="k.content" />
              </div>

              <div v-else-if="is_comment(k)">
                <div class="mt-5 mb-2">{{ k.title }}</div>
                <div class="content--comments">{{ k.content }}</div>
              </div>

              <div v-else>
                {{ k.title }} <v-chip class="ma-2"> {{ k.content }} </v-chip>
              </div>
            </div>
          </div>

          <div v-if="item.event_type === 'call_event'">
            <div class="d-flex align-center">
              {{ item.data.dst }}
              <div v-if="item.data.state">
                <v-chip class="ma-2" :color="get_icon_color(item.data.state)">
                  {{ $t(`autocaller_v2.stats.state.${item.data.state}`) }}
                </v-chip>
              </div>
              <audio-player
                :src="get_type(item).content.src"
                with_downloading
                :title="get_type(item).content.title"
                :content="get_type(item).content"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script>
  import AudioPlayer from '@app/plugins/audio-player/AudioPlayer';
  import { formatDate } from '@shared/helpers/date_format';
  import find from 'lodash-es/find';
  import Goods from './goods';

  export default {
    components: { Goods, AudioPlayer },
    props: {
      is_edit: {
        type: Boolean,
        default: false
      },
      items: {
        type: [Object, Array],
        default: () => {}
      },
      status_list: {
        type: Array,
        default: () => []
      },
      user_list: {
        type: Object,
        default: () => {}
      },
      is_loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      goods: []
    }),

    methods: {
      is_good_list(field) {
        return !!field?.goods;
      },
      is_comment(field) {
        return !!field?.comments;
      },
      format_date(date) {
        return date ? formatDate(date, 'DD.MM.YYYY hh:mm') : '';
      },
      get_classes(state) {
        return {
          'ml-3 mr-3': true,
          'success--text': state === 'ANSWERED',
          'error--text': state === 'NO_ANSWERED'
        };
      },
      get_type(item) {
        const { data } = item;
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (item.event_type) {
          case 'created': {
            return {
              icon: 'mdi-comment-plus-outline',
              title: this.$t('tasks.updated_fields.task_created'),
              tooltip: this.$t('tasks.updated_fields.task_created')
            };
          }
          case 'updated': {
            const updatedField = Object.keys(data)[0];
            let fieldTitle =
              Object.keys(data).length > 1
                ? this.$t('tasks.updated_fields.many_fields_title')
                : this.$t('tasks.updated_fields.updated_field');

            if (updatedField === 'comments') {
              return {
                icon: 'mdi-pencil',
                styleClasses: `content--${updatedField}`,
                tooltip: fieldTitle
              };
            } else {
              return {
                chips: true,
                icon: 'mdi-pencil',
                tooltip: fieldTitle
              };
            }
          }

          case 'call_event': {
            const { record, dst, call_date, state } = data;
            return {
              icon: 'mdi-phone',
              title: this.$t('tasks.updated_fields.call'),
              tooltip: this.$t('tasks.updated_fields.call'),
              content: {
                title: `${this.format_date(call_date)} ${dst}`,
                src: record,
                dst,
                state
              }
            };
          }
          default: {
            // return { icon: 'mdi-pencil', title: 'Обновлено поле' };
          }
        }
        /* eslint-enable */
      },
      get_icon_color(state) {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (state) {
          case 'ANSWERED': {
            return 'success';
          }
          case 'NO_ANSWERED': {
            return 'error';
          }
          default: {
            return 'primary';
          }
        }
        /* eslint-enable */
      },
      get_content(data) {
        const severalEvents = Object.keys(data).map((i) => {
          const fieldTitle =
            this.$t(`tasks.updated_fields.updated_field`) +
            ' ' +
            this.$t(`tasks.updated_fields.fields.${i}`);
          const content = data[i];

          /* eslint-disable no-unreachable, vue/script-indent */
          switch (i) {
            case 'task_state_id': {
              const stateName = find(this.status_list, { id: content }).name;
              return { content: stateName, title: fieldTitle };
            }
            case 'assigned_to': {
              const assignerName = find(this.user_list, { id: content }).name;
              return { content: assignerName, title: fieldTitle };
            }
            case 'items': {
              const parsedItems = JSON.parse(content);
              this.goods = parsedItems;
              return { goods: true, content: parsedItems, title: fieldTitle };
            }
            case 'comments': {
              return { comments: true, content, title: fieldTitle };
            }
            default: {
              return { content, title: fieldTitle };
            }
            /* eslint-enable */
          }
        });

        return severalEvents;
      }
    }
  };
</script>

<style lang="scss">
  .v-chip.v-size--default {
    border-radius: 5px;
    font-size: 12px;
    height: 25px;
  }
  .content {
    &--comments {
      color: #515a6e;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: inherit;
    }
  }
</style>
